import styled, { ThemeProvider } from 'styled-components';
import theme from '../../styles/theme';
import { useAuth, getRole } from "../../auth/AuthContext";

const Nav = styled.div`
    overflow: hidden;
    padding: 10px 20px;
    border-top: 2px solid black;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media screen and (max-width: 600px) {
        &.responsive {
            position: relative;
        }
    }
`;

const NavItem = styled.a`
    display: block;
    color: black;
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
    font-family: ${props => props.theme.font.family};
    font-size: ${props => props.theme.font.size.mediem};
    font-style: ${props => props.theme.font.style};
    background-color: #f2f2f2;
    border-radius: .25rem;
    cursor: pointer;

    &:hover {
        background-color: #ddd;
        color: black;
    }
`;

const Menu = () => {
    const { isAuthenticated, logout, azureLogin } = useAuth();
    const role = getRole();

    const handleAdminClick = () => {
        azureLogin();
    };

    return (
        <ThemeProvider theme={theme}>
            {isAuthenticated && (
                <Nav>
                    {role == 4 && (
                        <NavItem key={'/Admin'} href={'/Admin'} onClick={handleAdminClick}>Admin</NavItem>
                    )}
                    <NavItem key={'/'} href={'/'} onClick={logout}>Logout</NavItem>
                </Nav>
            )}
        </ThemeProvider>
    );
};

export default Menu;